// Public store destinations. iOS is live on the App Store (owner-supplied 2026-10-03,
// independently checked at webpage level). Android listing unchanged.
export const APP_DESTINATIONS = Object.freeze({
  googlePlay: "https://play.google.com/store/apps/details?id=gaamed.com",
  iosAppStore: "https://apps.apple.com/eg/app/gaamed/id6806704673",
});
